export default __webpack_public_path__ + "static/media/Punto_00_Darsena_Nuova_ENG_Def.c4d4c940.aac";